package org.matthewo.bracket


value class Divider internal constructor(val value: Int)

data class Dividers<T>(val spacings: List<Double>, val indices: Map<T, IntRange>)

data class DividerArea(val start: Divider, val end: Divider)

class DividerGenerator<T> {
    var dividers = 0
        private set
    private val spacers = mutableMapOf<Pair<Divider, Divider>, Double>()
    private val areas = mutableMapOf<T, DividerArea>()

    fun createArea(value: T, space: Double): DividerArea {
        val area = DividerArea(Divider(dividers), Divider(dividers + 1))
        areas[value] = area
        dividers += 2
        createSpace(area.start, area.end, space)
        return area
    }

    fun getArea(value: T) = areas[value]

    fun createSpace(a: Divider, b: Divider, space: Double) {
        spacers[a to b] = space
    }

    fun createSpace(a: Divider, space: Double): Divider {
        val divider = Divider(dividers)
        createSpace(a, divider, space)
        dividers += 1
        return divider
    }

    fun generate(): Dividers<T> {
        val adjacency = mutableMapOf<Divider, MutableList<Spacer>>()

        fun addAdjacent(a: Divider, b: Divider, space: Double) {
            adjacency.getOrPut(a) { [] } += Spacer(b, space)
        }

        spacers.entries.forEach { (p, space) ->
            val (a, b) = p
            addAdjacent(a, b, space)
            addAdjacent(b, a, -space)
        }

        val visited = mutableSetOf<Divider>()
        val locations = mutableListOf<Pair<Divider, Double>>()
        fun search(divider: Divider, start: Double) {
            visited += divider
            locations += divider to start
            for ((from, space) in adjacency.getOrElse(divider) { [] }) {
                if (from in visited) continue
                search(from, start + space)
            }
        }

        search(spacers.keys.first().first, 0.0)

        val sortedDividers = locations.sortedBy { it.second }
        val spacings = sortedDividers.zipWithNext().map { (a, b) ->
            b.second - a.second
        }
        val indices = sortedDividers.withIndex().associate { it.value.first to it.index }
        return Dividers(spacings, areas.entries.associate { it.key to (indices[it.value.start]!!..indices[it.value.end]!!) })
    }
}

private data class Spacer(val from: Divider, val space: Double)
